import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { environment } from "../../environments/environment";
import { Priorities, Statuses, Task, TaskLevel } from "../entities/Task";
import { Calendar } from "../entities/Calendar";
import { Resource } from "../entities/Resource";
import { ResourceTaskTime } from "../entities/ResourceTaskTime";
import { AppConfig } from '../app.config';
import { productModels } from '../../environments/environment';
import { SessionService } from './session.service';
import { Responsible } from 'app/entities/SalesPerson';
import { ExternalFilterField } from 'app/entities/ExternalFilterField';

export enum ColorCodes {
  DeepPink = "#ff1493", // Used for OTS marking
  LightBlue = "#00afff",
  Blue = "#003ff5",
  DarkBlue = "#00138d",
  LightGreen = "#38ff00",
  Green = "#0eb500",
  DarkGreen = "#0e6c00",
  LightYellow = "#e9ff00",
  Yellow = "#e9ed00",
  DarkYellow = "#aeaa00",
  LightBrown = "#ba681e",
  Brown = "#a0522d",
  DarkBrown = "#643213",
  LightPurple = "#b591ff",
  Purple = "#8a2be2",
  DarkPurple = "#8b008b",
  LightOrange = "#ffb100",
  Orange = "#ff7c47",
  DarkOrange = "#ff4500",
  Grey = "#808080",
  SandColor = "#f0e68c"
}

export const FilterMapping = {
  'App_Category_Filter': 'APPTASKCATEGORY',
  'App_Company_Filter': 'COMPANY',
  'App_Responsible_Filter': "RESPONSIBLE",
  'App_Status_Filter': "STATUS",
  'App_Show_OTS_Filter': "TASKLEVEL"
}

export enum MaintenanceColorCodes {
  Released = '#8c8c8c',
  Active = '#33cc33',
  Completed = '#00ccff',
  Planned = '#ffb100',
  NotCompleted = '#333399'
}

@Injectable()
export class ConverterService {

  Priorities = Priorities;
  Statuses = Statuses;

  TasksArray: Task[];
  Colors = ['#FF4118',
    '#F1EE00',
    '#00DA0A',
    '#00DAD0',
    '#2E4053',
    '#004CDA',
    '#9F00DA',
    '#DA00AC',
    '#138D75',
    '#DA000D'];

    // <--- locale convertions used in datepicker and fullcalendar --->
    languages = new Map<string, string>([
      [ 'DAN', 'da' ],
      [ 'ENU', 'en' ],
      [ 'FRA', 'fr' ],
    ]);


  public productModels = productModels;
  public currentProductModel: any;

  constructor(private appConfig: AppConfig, private sessionService: SessionService) {
    this.currentProductModel = this.appConfig.getConfig("productModel");
  }



  // This convert method changed the dates so they are displayed correctly in the Calenders.
  // Whole days returns: End is plussed with 1 day so it is displayed correctly.
  // Partial days returns: No changed.
  convertToCalendar(calendar: Calendar): Calendar {
    for (let t of calendar.ResourceTaskTimes) {
      t.title = t.JobNo + " - " + t.Title;
      t.Title = t.JobNo + " - " + t.Title;

      t.resourceId = t.ResourceRef;
      t.OrigResourceRef = t.ResourceRef;
      t.id = t.TaskRef + t.ResourceRef + t.TimePlanRef;



      let sdate = moment(t.start);
      let edate = moment(t.end);

      let e = new Date(t.end);

      // Hvis tidspunktet i startsdatoen er == 00:00:00, gør følgende.
      if (sdate.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
        t.start = sdate.format(environment.START_DATETIME_FORMAT);

        edate = moment(e.setDate(e.getDate() + 1));
        t.end = edate.format(environment.START_DATETIME_FORMAT);
      }
      else {
        t.start = sdate.format(environment.FULL_DATETIME_FORMAT);

        t.end = edate.format(environment.FULL_DATETIME_FORMAT);
      }

      let s = new Date(t.start);
      if (e < s || t.end == environment.DEFAULT_DATETIME_FULL || t.end == environment.DEFAULT_DATETIME_START) {
        t.end = null;
      }


      if (t.Priority == this.Priorities[1]) {
        t.Icon = 'exclamation-triangle'
      }


      switch (t.Status) {
        case this.Statuses[0]:
          t.editable = true;
          break;
        case this.Statuses[1]:
          t.color = '#064d80';
          t.editable = true;
          break;
        case this.Statuses[2]:
          t.color = '#378006';
          t.editable = false;
        case this.Statuses[3]:
          t.color = '#378006';
          t.editable = false;
      }

      t.editable = !t.IsApproved;
      if (t.IsApproved) {
        t.color = '#378006';
      }
    }
    return calendar;
  }

  convertTasksToResources(tasks: Task[], showDates: boolean) {
    let resourceTasks: Resource[];
    resourceTasks = [];

    // NM 240420 >>

    let maxLengthTask = new Task(); //tasks.reduce((acc, val) => ( acc === undefined || this.getLength(val) > this.getLength(acc)) ? val : acc)

    // NM 240420 <<

    for (let t of tasks) {

      resourceTasks.push(this.ConvertToResourceTask(t, showDates, maxLengthTask));
    }

    return resourceTasks;
  }

  getLength(task) {
    return task.Title.length + task.JobTaskNo.length;
  }

  convertTasksToPlacedTasks(placed: Task[], resources: Resource[]): ResourceTaskTime[] {
    let placedTasks: ResourceTaskTime[];
    placedTasks = [];
    let resourcesCopy = JSON.parse(JSON.stringify(resources))
    for (let t of resourcesCopy) {

      t.start = this.getDateOrDefault(t.start);
      t.end = this.getDateOrDefault(t.end);

      let constraint = this.ConvertResourceToConstraint(t);
      placedTasks.push(constraint);

      let placableTask = placed.filter(x => x.No == t.No);
      if (placableTask.length > 0) {
        let placedTask = this.ConvertToPlacedTask(placableTask[0]);

        placedTasks.push(placedTask);
      }
    }
    return placedTasks;
  }

  getDateOrDefault(date: string): string {
    let momentDate = moment(date);

    if (momentDate.utc().format(environment.FULL_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_FULL || date == environment.DEFAULT_DATETIME_START) {
      return null;
    }
    return date;
  }

  // This converter method changes the dates before they are saved to NAV
  // Returns: If event is whole day/days: End date is being substacted with 1 day so it is displayed correct in NAV. Start and end dont have time stamps.
  // Returns: If event is part of a day: Start and end have time stamps.
  public ConvertFromSchedulerDate(event: any, fromScheduler: boolean) {
    let checkStartDate = event.start;
    let checkEndDate = event.end;

    checkStartDate = new Date(checkStartDate.format());
    checkEndDate = new Date(checkEndDate.format());

    // If it is a all day event, where the days are different (All dag events are);
    if (checkEndDate.getDate() != checkStartDate.getDate()) {
      if (fromScheduler) {
        event.start = new Date(event.start);
        let s = moment(event.start.setHours(event.start.getHours() + 3));
        event.start = s.format(environment.START_DATETIME_FORMAT);
      }
      else {
        event.start = event.start.format(environment.START_DATETIME_FORMAT);
      }

      event.end = new Date(event.end);
      if (fromScheduler) {
        event.end = new Date(event.end.setHours(event.end.getHours() + 3));
      }
      // Vi fjern en dag fra enddate, da vi pludsede med en da vi indsatte dem i kalenderen.
      event.end = moment(event.end.setDate(event.end.getDate() - 1));
      event.end = event.end.format(environment.START_DATETIME_FORMAT);
    }
    // Else its is as a Hour based event
    else {
      event.start.format();
      event.end.format();
    }
    return event;
  }

  public ConvertToResourceTask(t: Task, showDate: boolean, maxLengthTask: Task): Resource {
    let jobTask = new Resource();
    jobTask.id = t.Task_GUID;
    jobTask.No = t.No;
    jobTask.start = t.start;
    jobTask.end = t.end;

    if (this.currentProductModel == productModels.Premium) {
      jobTask.title = t.Job_Task_No + " - " + t.Title;
    }
    if (this.currentProductModel == productModels.Lite) {
      jobTask.title = t.Job_Task_No + " - " + t.Title;
    }
    if (this.currentProductModel == productModels.Maintenance) {
      jobTask.title = t.No + " - " + t.Title;
    }

    jobTask.Title = t.Title;
    jobTask.Name = t.Title;

    let sdate = moment(t.start);
    let edate = moment(t.end);

    let e = new Date(t.end);

    // FORKERT!! Hvis tidspunktet i startsdatoen er == 00:00:00, gør følgende.
    if (sdate.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
      // Hvis stardate og enddate IKKE er den samme, skal vi pludse enddate med 1, eftersom at Fullcalendar/Scheduler ikke visualisere den sidste dag.
      //if(sdate.format(environment.START_DATETIME_FORMAT) != edate.format(environment.START_DATETIME_FORMAT)){
      jobTask.start = sdate.format(environment.START_DATETIME_FORMAT);;
      // Set the end date one day forward. because the calendar dosent include the last.
      edate = moment(e.setDate(e.getDate() + 1));
      jobTask.end = edate.format(environment.START_DATETIME_FORMAT);
    }
    else {
      jobTask.start = sdate.format(environment.FULL_DATETIME_FORMAT);

      jobTask.end = edate.format(environment.FULL_DATETIME_FORMAT);
    }

    jobTask.JobTaskNo = t.Job_Task_No;
    jobTask.Customer = t.Customer_Name;

    if (this.currentProductModel == productModels.Premium) {
      jobTask.Job_Description = t.Job_Description;
    }
    if (this.currentProductModel == productModels.Lite) {
      jobTask.Job_Description = t.Job_Description;
    }
    else if (this.currentProductModel == productModels.Maintenance) {
      jobTask.Job_Description = t.Desciption;
    }
    jobTask.CalcEstimate = +t.Planned_Hours;
    jobTask.Responsible = this.sessionService.getCompanyType() === TaskLevel.OTS ? t.OTS_Responsible : t.Responsible;
    jobTask.Maintenance_Object = t.Maintenance_Object;
    jobTask.App_Task_Category_Description = t.App_Task_Category_Description;

    return jobTask;
  }



  private ConvertToPlacedTask(t: Task): ResourceTaskTime {
    let Sdate = moment(t.start);
    let Edate = moment(t.end);
    let placedTask = new ResourceTaskTime();
    placedTask.resourceId = t.Task_GUID;
    placedTask.id = t.No;
    placedTask.Title = t.Title;
    placedTask.TaskLevel = t.Task_Level;

    if (t.Task_Level === TaskLevel.OTS) {
      placedTask.borderColor = ColorCodes.DeepPink;
    }

    if (this.currentProductModel == productModels.Premium) {
      placedTask.title = t.Job_Task_No + " - " + t.Title + " - " + Sdate.format(environment.START_DATETIME_FORMAT_DANISH) + " - " + Edate.format(environment.START_DATETIME_FORMAT_DANISH);
      placedTask.Job_Description = t.Job_Description;
      // !Maintenance
      placedTask.color = ColorCodes[t.ColorCode];
      if (t.Status == 'Planned') {
        placedTask.Icon = 'check'
      }
    }
    else if (this.currentProductModel == productModels.Lite) {
      placedTask.title = t.Job_Task_No + " - " + t.Title + " - " + Sdate.format(environment.START_DATETIME_FORMAT_DANISH) + " - " + Edate.format(environment.START_DATETIME_FORMAT_DANISH);
      placedTask.Job_Description = t.Job_Description;
    }
    else if (this.currentProductModel == productModels.Maintenance) {
      placedTask.title = t.No + " - " + t.Title;// + " - " + Sdate.format(environment.START_DATETIME_FORMAT_DANISH) + " - " + Edate.format(environment.START_DATETIME_FORMAT_DANISH);
      placedTask.Job_Description = t.Desciption;
      // Maintenance
      placedTask.color = this.setRTTColorCode(t.Status);
    }
    placedTask.TaskRef = t.Task_GUID;
    placedTask.constraint = t.Task_GUID;


    if (t.Priority == this.Priorities[1]) {
      placedTask.Icon = 'exclamation-triangle';
      placedTask.IconColor = this.Colors[0];
    }


    placedTask.Customer = t.Customer_Name;
    placedTask.editable = true;

    placedTask.CalcEstimate = +t.Planned_Hours;

    placedTask.Maintenance_Object = t.Maintenance_Object;
    placedTask.App_Task_Category_Description = t.App_Task_Category_Description;
    placedTask.Company_Reference = t.Company_Reference;

    let sdate = moment(t.start);
    let edate = moment(t.end);

    let e = new Date(t.end);

    if (this.currentProductModel == productModels.Maintenance) {
      // Maintenance should only work with whole days, not hours. >>
      placedTask.start = sdate.format(environment.START_DATETIME_FORMAT);
      edate = moment(e.setDate(e.getDate() + 1));
      placedTask.end = edate.format(environment.START_DATETIME_FORMAT);
      // Maintenance should only work with whole days, not hours. <<
    }
    else {
      // Hvis tidspunktet i startsdatoen er == 00:00:00, gør følgende.
      if (sdate.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
        // Hvis stardate og enddate IKKE er den samme, skal vi pludse enddate med 1, eftersom at Fullcalendar/Scheduler ikke visualisere den sidste dag.
        placedTask.start = sdate.format(environment.START_DATETIME_FORMAT);;
        // Set the end date one day forward. because the calendar dosent include the last.
        edate = moment(e.setDate(e.getDate() + 1));
        placedTask.end = edate.format(environment.START_DATETIME_FORMAT);
      }
      else {
        placedTask.start = sdate.format(environment.FULL_DATETIME_FORMAT);

        placedTask.end = edate.format(environment.FULL_DATETIME_FORMAT);
      }
    }
    return placedTask;
  }

  setRTTColorCode(status: string): string{
    let localStatus = status;
    //Remove any whitespace in status
    if (status.includes(' ')) {
      localStatus = status.replace(/\s/g, '')
    }
    return MaintenanceColorCodes[localStatus];
  }


  public ConvertToConstraint(t: Task): ResourceTaskTime {
    let constraint = new ResourceTaskTime();
    constraint.id = t.Task_GUID;
    constraint.start = '1990-01-01T00:00:00';
    constraint.end = '2050-01-01T00:00:00';
    constraint.color = '#cccccc';
    constraint.rendering = 'background';
    constraint.resourceId = t.No;
    return constraint;
  }

  public ConvertResourceToConstraint(t: Resource): ResourceTaskTime {
    let constraint = new ResourceTaskTime();
    constraint.id = t.id;
    constraint.start = '1990-01-01T00:00:00';
    constraint.end = '2050-01-01T00:00:00';
    constraint.color = '#cccccc';
    constraint.rendering = 'background';
    constraint.resourceId = t.id;
    return constraint;
  }

  public ConvertToProgress(t: Task): ResourceTaskTime {
    let constraint = new ResourceTaskTime();
    constraint.id = '1';
    constraint.start = t.start;
    constraint.end = t.end;
    constraint.color = this.Colors[4];
    constraint.rendering = 'background';
    return constraint;
  }

  public ConvertToTaskConstraint(t: Task): ResourceTaskTime {
    let constraint = new ResourceTaskTime();
    constraint.id = t.Task_GUID;
    let s = new Date(t.start);
    constraint.start = moment(s.setDate(s.getDate())).format(environment.FULL_DATETIME_FORMAT).toString();
    let e = new Date(t.end);
    constraint.end = moment(e.setDate(e.getDate() + 1)).format(environment.FULL_DATETIME_FORMAT).toString();
    constraint.color = '#138D75';
    constraint.rendering = 'background';

    return constraint;
  }

  public ConvertToVisualConstraint(id: string, start: string, end: string): ResourceTaskTime {
    let constraint = new ResourceTaskTime();
    constraint.id = id;
    let s = new Date(start);
    constraint.start = moment(s.setDate(s.getDate())).format(environment.FULL_DATETIME_FORMAT).toString();
    let e = new Date(end);
    constraint.end = moment(e.setDate(e.getDate() + 1)).format(environment.FULL_DATETIME_FORMAT).toString();
    constraint.color = '#138D75';
    constraint.rendering = 'background';
    return constraint;
  }


  public DatesToString(start, end) {
    let formattedStartDate = moment(new Date(start)).format(environment.START_DATETIME_FORMAT_DANISH);

    return formattedStartDate != environment.DEFAULT_DATETIME_START_DANISH ?
      (formattedStartDate + ' - ' + (end != null ? moment(new Date(end).setDate(new Date(end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH) : formattedStartDate))
      : "";
  }


  chunk(str, n, maxSentenceLength = undefined) {
    var ret = [];
    var i;
    var len;

    var spaceMet: boolean;
    var timeForNewLine: boolean;
    var lastToIndex: number = 0

    if (str != undefined) {
      // remove existing newlines (\n)
      str = str.replace(/\n/g, '');

      for (i = 1, len = str.length; i <= len; i++) {
        if (Math.abs(lastToIndex - i) >= n) {
          timeForNewLine = true;
        }
        if (timeForNewLine && str[i] == ' ') {
          spaceMet = true;
        }
        if (i == len) {
          spaceMet = true;
        }

        if (spaceMet) {
          timeForNewLine = false;
          spaceMet = false;
          var lineOfText = str.substr(lastToIndex, i - lastToIndex);
          lastToIndex = i;
          ret.push(lineOfText);

          // Get longest line of text
          if (maxSentenceLength != undefined) {
            if ((lineOfText.length) > maxSentenceLength) {
              maxSentenceLength = (lineOfText.length)
            }
          }
        }
      }
    }

    return { chunks: ret, characterLength: maxSentenceLength }
  }

  public UserFilterToSalesPerson(input: string): string {
    let _filterMapping = { ...FilterMapping }

    if (this.isSelectedCompanyOTS) {
      _filterMapping.App_Responsible_Filter = "OTS_RESPONSIBLE"
    }
    if (input in _filterMapping) {
      return _filterMapping[input]
    }
  }

  public ConvertFilterValues(filters: Responsible): ExternalFilterField[] {
    const filterNames = Object.keys(FilterMapping)
    let filterFields: ExternalFilterField[] = [];

    filterNames.forEach((filterName, index) => {
      //Prevent undefined values beeing added to the string
      if (!!filters[filterName] && filters.hasOwnProperty(filterName)) {
        const filterValues: string[] = filters[filterName].split("|");
        filterValues.forEach((value) => {
          const filterField: ExternalFilterField = {
            SalesPerson_Code: '',
            View_Name: '',
            Field_Name: this.UserFilterToSalesPerson(filterNames[index]),
            Field_Value: value
          }
          if (!this.isFilterInList(filterField, filterFields) && filterField.Field_Value !== '') {
            filterFields.push(filterField);
          }
        })
      }
    })
    return filterFields;
  }

  isFilterInList(filterField: ExternalFilterField, filterFields: ExternalFilterField[]): boolean {
    if (filterFields.find(filter => filter.Field_Name === filterField.Field_Name && filter.Field_Value === filterField.Field_Value)) {
      return true
    }
    return false;
  }

  get isSelectedCompanyOTS(): boolean {
    return this.sessionService.getCompanyType() === TaskLevel.OTS;
  }
  
  public URLLanguageParamToFullCalendarFormat(language: string): string{
    const lang = this.languages.get(language);
    return lang;
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/converter.service.ts